var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "emoji-like") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Navigation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XX---UI-elements-(buttons,-tabs,-etc)",
    transform: "translate(-404.000000, -1545.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(69.500000, 798.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "emoji-like",
    transform: "translate(335.500000, 748.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9997838,1.687539e-13 C24.8221622,1.687539e-13 31.9995676,7.17751351 31.9995676,15.9997838 C31.9995676,24.8220541 24.8220541,31.9995676 15.9997838,31.9995676 C7.17751351,31.9995676 -3.4283687e-13,24.8220541 -3.4283687e-13,15.9997838 C-3.4283687e-13,7.17751351 7.17751351,1.687539e-13 15.9997838,1.687539e-13 Z",
    id: "Combined-Shape",
    stroke: "#5787E5",
    fill: "#5787E5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 5.880000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1072,1.18725926 C11.5232,-0.617370852 14.3936,-0.292942966 14.1856,1.67390109 C13.9776,3.70157538 13.5616,4.37070789 13.2496,6.33755195 C13.208,6.6011496 13.3952,6.82419377 13.6656,6.82419377 L13.6656,6.82419377 L18.304,6.82419377 C19.0944,6.82419377 19.76,7.47304955 19.76,8.24356577 C19.76,9.014082 19.1152,9.66293777 18.304,9.66293777 L18.304,9.66293777 L18.0752,9.66293777 C18.928,9.66293777 19.6352,10.4131773 19.4896,11.3053539 C19.4064,12.0353167 18.7408,12.5422353 17.992,12.5422353 L17.992,12.5422353 L17.8256,12.5422353 C18.6992,12.5422353 19.4064,13.2924747 19.2816,14.1643747 C19.1984,14.8943374 18.5328,15.401256 17.784,15.401256 L17.784,15.401256 L17.5968,15.401256 C18.3872,15.401256 19.0528,16.029835 19.0528,16.820628 C19.0528,17.5911442 18.408,18.24 17.5968,18.24 L17.5968,18.24 L12.2512,18.24 C8.84,18.24 7.6752,17.3072698 6.656,16.8814582 C6.3856,16.7597978 6.1984,16.4962001 6.1984,16.2123257 L6.1984,16.2123257 L6.1984,8.10162857 C6.1984,7.85830766 6.3232,7.65554023 6.5104,7.51360303 C7.4672,6.84447052 10.3376,4.57347532 11.1072,1.18725926 Z M4.3264,7.69609372 C4.7424,7.69609372 5.0752,8.0205216 5.096,8.42605646 L5.096,8.42605646 L5.096,15.9487281 C5.096,16.3542629 4.7632,16.6786908 4.3472,16.6786908 L4.3472,16.6786908 L0.7488,16.6786908 C0.3328,16.6786908 0,16.3542629 0,15.9487281 L0,15.9487281 L0,8.42605646 C0,8.0205216 0.3328,7.69609372 0.7488,7.69609372 L0.7488,7.69609372 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiLike);
export default __webpack_public_path__ + "static/media/emoji-like.de73a276afd77498c9a59bf19c2dce54.svg";
export { ForwardRef as ReactComponent };